import React, { useState } from 'react';
import { styled, Input, Button, Modal, SubTitle, Body, ModalBody, Flex } from '@teko/ds-desktop';
import { isValidPhoneFormat } from '@teko/utils';
import { logger } from '@teko/log';
import { getCountDownDisplay } from '../../helper.es.js';
import { OTPInput } from '../OTPInput/OPTInput.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const StyledPhoneInput = styled(Input)`
  margin-top: 20px;
`;
const ResendOtpBtn = styled(Button)`
  font-size: 14px;
  line-height: 20px;
  width: 100%;
  text-align: center;
`;
const SendOtpBtn = styled(Button)`
  height: 32px;
  padding: 0 30px;
  margin-bottom: 0.5rem;
  text-align: center;
`;
const StyledNoti = styled.div`
  color: #eb1f3a;
  text-align: center;
  margin: 1rem auto;
`;
const Center = styled.div`
  display: flex;
  justify-content: center;
`;
const defaultCountdown = 60;
const UpdatePhoneNumberModal = (props) => {
  const {
    visible,
    setVisible,
    authService,
    user,
    setUser,
    callbackConfirmOtp,
    otpRequestCountDown: totalCountdown
  } = props;
  const [, setLoading] = useState(true);
  const [phone, setPhone] = useState("");
  const [isSentOTP, setSentOTP] = useState(false);
  const [countDown, setCountDown] = useState(totalCountdown || defaultCountdown);
  const [intervalId, setIntervalId] = useState();
  const [noti, setNoti] = useState({
    show: false,
    message: ""
  });
  const updatePhone = async (otp) => {
    var _a, _b, _c, _d;
    setLoading(true);
    try {
      const data = await authService.updatePhone(phone, otp);
      setUser(__spreadProps(__spreadValues({}, user), { telephone: data.phone_number }));
      setVisible(false);
    } catch (error) {
      logger.error(error);
      if (((_b = (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.error) == null ? void 0 : _b.code) === 1041) {
        setNoti({
          show: true,
          message: "M\xE3 x\xE1c nh\u1EADn kh\xF4ng \u0111\xFAng. Vui l\xF2ng th\u1EED l\u1EA1i"
        });
      } else {
        setNoti({ show: true, message: (_d = (_c = error == null ? void 0 : error.response) == null ? void 0 : _c.error) == null ? void 0 : _d.message });
      }
    } finally {
      setLoading(false);
    }
  };
  const sendOTP = async () => {
    var _a, _b, _c, _d;
    setLoading(true);
    try {
      await authService.verifyPhone(phone != null ? phone : "");
      setSentOTP(true);
      setCountDown(totalCountdown || defaultCountdown);
      const handle = setInterval(() => {
        setCountDown((countdown) => countdown === 0 ? countdown : countdown - 1);
      }, 1e3);
      setIntervalId(handle);
    } catch (error) {
      logger.error(error);
      if (((_b = (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.error) == null ? void 0 : _b.code) === 1019) {
        setNoti({
          show: true,
          message: "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u0111\xE3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 \u0111\u0103ng k\xFD m\u1ED9t t\xE0i kho\u1EA3n kh\xE1c"
        });
      } else {
        setNoti({ show: true, message: (_d = (_c = error == null ? void 0 : error.response) == null ? void 0 : _c.error) == null ? void 0 : _d.message });
      }
    } finally {
      setLoading(false);
    }
  };
  const handlePhoneChange = (number) => {
    setPhone(number);
    setNoti(isValidPhoneFormat(number) ? { show: false, message: "" } : { show: true, message: "Vui l\xF2ng nh\u1EADp \u0111\xFAng \u0111\u1ECBnh d\u1EA1ng s\u1ED1 \u0111i\u1EC7n tho\u1EA1i" });
  };
  const checkEnterOnPhoneInput = (e) => {
    if (e.which === 13 || e.keyCode === 13) {
      sendOTP();
    }
  };
  const handleResendOtp = async () => {
    if (countDown === 0) {
      clearInterval(intervalId);
      setNoti({ show: false, message: "" });
      sendOTP();
    }
  };
  const handleOtpChange = async (otp) => {
    if (otp.length === 6) {
      await updatePhone(otp);
      callbackConfirmOtp == null ? void 0 : callbackConfirmOtp();
    }
  };
  const onClose = () => {
    setVisible(false);
    authService.logout();
  };
  const countDownDisplay = getCountDownDisplay(countDown);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Modal, {
    visible: visible && !isSentOTP,
    footer: false,
    onClose,
    centeredTitle: true,
    disableEscClose: true,
    title: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SubTitle, {
      level: 1,
      color: "textTitle"
    }, "B\u1ED5 sung th\xF4ng tin"), /* @__PURE__ */ React.createElement(Body, {
      level: 1,
      marginTop: "s8"
    }, "Vui l\xF2ng cung c\u1EA5p th\xF4ng tin s\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u0111\u1EC3 kh\xF4ng b\u1ECF l\u1EE1 c\xE1c ch\u01B0\u01A1ng tr\xECnh khuy\u1EBFn m\xE3i \u0111\u1EB7c bi\u1EC7t t\u1EDBi t\u1EEB Co-op Online"))
  }, /* @__PURE__ */ React.createElement(ModalBody, {
    padding: ["s0", "s0"]
  }, /* @__PURE__ */ React.createElement(SubTitle, null, "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i"), /* @__PURE__ */ React.createElement(StyledPhoneInput, {
    value: phone,
    onChange: handlePhoneChange,
    onKeyUp: checkEnterOnPhoneInput,
    placeholder: "Nh\u1EADp s\u1ED1 \u0111i\u1EC7n tho\u1EA1i"
  }), noti.show && /* @__PURE__ */ React.createElement(StyledNoti, null, noti.message)), /* @__PURE__ */ React.createElement(Flex, {
    justify: "center"
  }, /* @__PURE__ */ React.createElement(SendOtpBtn, {
    marginTop: "s16",
    variant: "primary",
    disabled: !isValidPhoneFormat(phone),
    onClick: () => sendOTP()
  }, "Ti\u1EBFp t\u1EE5c"))), /* @__PURE__ */ React.createElement(Modal, {
    visible: visible && isSentOTP,
    footer: false,
    showCloseIcon: false,
    centeredTitle: true,
    title: /* @__PURE__ */ React.createElement(SubTitle, {
      level: 1,
      color: "textTitle"
    }, "M\xE3 x\xE1c th\u1EF1c")
  }, /* @__PURE__ */ React.createElement(ModalBody, {
    padding: ["s0", "s0"]
  }, /* @__PURE__ */ React.createElement(Body, {
    level: 1,
    marginTop: "s8"
  }, `Vui l\xF2ng nh\u1EADp m\xE3 x\xE1c nh\u1EADn OTP \u0111\xE3 \u0111\u01B0\u1EE3c g\u1EEDi v\u1EC1 s\u1ED1 \u0111i\u1EC7n tho\u1EA1i ${phone}`), /* @__PURE__ */ React.createElement(OTPInput, {
    onChange: (otp) => handleOtpChange(otp)
  }), noti.show && /* @__PURE__ */ React.createElement(StyledNoti, null, noti.message), /* @__PURE__ */ React.createElement(Center, null, /* @__PURE__ */ React.createElement(ResendOtpBtn, {
    disabled: countDown > 0,
    onClick: handleResendOtp,
    variant: "link"
  }, countDownDisplay)))));
};

export { UpdatePhoneNumberModal };
